<template>
    <div 
        v-if="visible" class="position-fixed top-0 end-0 h-100 d-flex align-items-stretch"
        style="z-index: 9999; pointer-events: none;"
        :class="{ 'w-100': isMobile }"
     >
        <div 
            class="bg-white d-flex flex-column shadow-lg side-panel p24" 
            :class="{ 'side-panel-open': visible }"
            style="pointer-events: auto;"
            ref="panel"
        >
            <div class="d-flex align-items-top justify-content-between" v-if="title || $slots.header || ($store.state.sidePanel.content && $store.state.sidePanel.content.component === 'AMLCheck')">
                <Icon
                    v-if="isMobile" 
                    name="arrow-left" 
                    class="pointer"  
                    @click="close"
                />
                <slot name="header">
                    <div v-if="$store.state.sidePanel.content && $store.state.sidePanel.content.component === 'AMLCheck'" class="flex-grow-1">
                        <div>
                            <h2 v-if="!title" class="fsp20 neue mb-2 mbp-4">{{ $t('components.service.SidePanel.1') }}</h2>
                            <h2 v-else class="fsp20 neue mb-2 mbp-4">{{ title }}</h2>
                            <p class="mb-0 fsp14 grey neue-roman">{{ $t('components.service.SidePanel.2') }}</p>
                        </div>
                    </div>    
                    <div v-else-if="$store.state.sidePanel.content && $store.state.sidePanel.content.component === 'NotificationPanel'" class="flex-grow-1">
                        <h2 class="fsp20 neue mb-0" :class="{ 'text-center': isMobile, 'mb4': !isMobile }">{{ $t('components.service.Informator.19') }}</h2>
                        <p v-if="!isMobile" class="mb-0 fsp14 grey neue-roman">
                            {{ $t('components.service.Informator.20', { count: $store.getters['informator/unreadTodayCount'] }) }} 
                            {{ $lib.pluralize($store.getters['informator/unreadTodayCount'], [this.$t('components.service.Informator.21'), this.$t('components.service.Informator.22'), this.$t('components.service.Informator.23')]) }} 
                            {{ $t('components.service.Informator.24') }}
                        </p>
                        <div class=""></div>
                    </div>
                </slot>
                <Icon 
                    v-if="!isMobile"
                    name="close" 
                    class="pointer" 
                    @click="close"
                />
            </div>
            <div class="myp-16" style="border-top: 1px solid #EFEFEF;"></div>
            <div class="test"></div>
            <div class="scroll-custom flex-grow-1 overflow-auto">
                <component 
                    v-if="$store.state.sidePanel.content && $store.state.sidePanel.content.component" 
                    :is="$store.state.sidePanel.content.component"
                    v-bind="$store.state.sidePanel.content.props || {}"
                    @close="close"
                />
                <slot v-else></slot>
            </div>
        </div>
    </div>
</template>

<script>
import AMLCheck from '@/components/service/AMLCheck';
import Icon from '@/components/icons/Icon';
import NotificationPanel from './NotificationPanel.vue';

export default {
    name: 'SidePanel',
    components: {
        AMLCheck,
        Icon,
        NotificationPanel
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        closeOnOverlay: {
            type: Boolean,
            default: true
        }
    },
    mounted() {
        if (this.visible) {
            this.focusPanel();
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.focusPanel();
                });
            }
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        focusPanel() {
            if (this.$refs.panel) {
                this.$refs.panel.focus();
            }
        },
        handleKeydown(event) {
            if (event.key === 'Escape') {
                this.close();
            }
        }
    },
    created() {
        document.addEventListener('keydown', this.handleKeydown);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeydown);
        this.removeBodyClass();
    }
}
</script>

<style lang="scss" scoped>
.side-panel {
    width: 512px;
    height: 100vh;
    max-height: 100vh;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
    outline: none;
    
    &.side-panel-open {
        transform: translateX(0);
    }
    
    @media (max-width: 768px) {
        width: 100vw;
        
        h2 {
            text-align: center;
        }
        
        p {
            display: none;
        }
    }
}

.scroll-custom {
    
    /* Кастомный скроллбар */
    &::-webkit-scrollbar {
        width: 6px;
        margin-left: 8px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f5f9;
        border-radius: 3px;
        margin-left: 8px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: $menu-bg;
        border-radius: 3px;
        
        &:hover {
            background: $menu-bg2;
        }
    }
    
    &::-webkit-scrollbar-button {
        display: none;
    }
}

</style>
